import { Component, ContentChildren, EventEmitter, Input, Output, QueryList } from '@angular/core';
import { ButtonBaseComponent } from '../button-base.component';
import { ToggleButtonComponent } from '../toggle-button/toggle-button.component';

@Component({
    selector: 'lib-button-toggle-group',
    templateUrl: './button-toggle-group.component.html',
    styleUrl: './button-toggle-group.component.scss'
})
export class ButtonToggleGroupComponent <T> extends ButtonBaseComponent {
    private _selected!: T;

    @Input() set currentSelection(value: T) {
        this._selected = value;
    }
    @Output() selectionChange: EventEmitter<T> = new EventEmitter();

    @ContentChildren(ToggleButtonComponent) options!: QueryList<ToggleButtonComponent<T>>;

    ngAfterContentInit() {
        if (!this._selected && this.options.length) {
            this._selected = this.options.first.value;
        }
    }

    SelectionChange(event: T) {
        if (event) {
            this._selected = event;
            this.selectionChange.emit(event);
        }
    }

    get selected(): T {
        return this._selected;
    }
}
